/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import { useEditor, EditorContent } from "@tiptap/react";
// import { Paragraph } from '@tiptap/core';
import { marked } from "marked";

import StarterKit from "@tiptap/starter-kit";
import { TextStyleKit } from "@tiptap/extension-text-style";
import { Color } from "@tiptap/extension-color";
import { TaskList } from "@tiptap/extension-task-list";
import { TaskItem } from "@tiptap/extension-task-item";
// import Document from '@tiptap/extension-document'
// import Dropcursor from '@tiptap/extension-dropcursor'
import Image from "@tiptap/extension-image";
import Highlight from "@tiptap/extension-highlight";
import { Table } from "@tiptap/extension-table";
import { TableRow } from "@tiptap/extension-table-row";
import { TableCell } from "@tiptap/extension-table-cell";
import { TableHeader } from "@tiptap/extension-table-header";
import { db, auth } from "../../../firebaseConfig";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import _ from "lodash";
import CustomBubbleMenu from "./BubbleMenu";
import { config } from "dotenv";
// import TiptapSideMenu from "../MaterialUI/TiptapSideMenu";
import "./Tiptap.css";
const EditorsContainer = ({ content, id, geminiData, onEditing, editable, onFocus, onBlur }) => {
  return (
    <div className="component-content">
      {/* {`${id} editable: ${editable}`} */}
      <div key={id}>
        <TiptapEditor
          initialContent={content}
          editorId={id}
          geminiData={geminiData}
          // onFirestoreUpdated={onFirestoreUpdated}
          onEditing={onEditing}
          editable={editable}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      </div>
    </div>
  );
};

const TiptapEditor = React.memo(function TiptapEditor({ editorId, initialContent, geminiData, onEditing = () => {}, editable, onFocus, onBlur }) {
  const { viewId } = useParams();
  // const [menuPosition, setMenuPosition] = useState(null);
  // const [showSideMenu, setShowSideMenu] = useState(false);
  const editorRef = useRef(null);

  const [isTyping, setIsTyping] = useState(false);
  const typingTimer = useRef(null);

  const handleTyping = useCallback(() => {
    setIsTyping(true);
    if (typingTimer.current) {
      clearTimeout(typingTimer.current);
    }
    typingTimer.current = setTimeout(() => {
      setIsTyping(false);
    }, 1000);
  }, []);

  // const throttledFirestoreUpdated = useCallback(_.throttle(onFirestoreUpdated, 1000), [onFirestoreUpdated]);

  const updateFirestore = useCallback(
    async (content) => {
      const currentUser = auth.currentUser;
      if (!currentUser) {
        console.error("No authenticated user found.");
        return;
      }

      const docRef = doc(db, "views", viewId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        let newContents = docSnap.data().contents || [];
        const index = newContents.findIndex((c) => c.id === editorId);

        if (index >= 0) {
          newContents[index] = { ...newContents[index], content };
        } else {
          newContents.push({
            id: editorId,
            type: "text-editor",
            content,
            cards: 1,
          });
        }

        await updateDoc(docRef, { contents: newContents });
        console.log("Content updated successfully in Firestore.");
        // throttledFirestoreUpdated();
      }
    },
    [viewId, editorId]
  );

  const debouncedUpdateFirestore = useCallback(_.debounce(updateFirestore, 1000), [updateFirestore]);

  const parseContent = (content) => {
    if (!content) return "";
    if (typeof content !== 'string') return content;
    // Check if content looks like HTML. If so, return as is.
    const isHtml = content.trim().startsWith('<');
    return isHtml ? content : marked(content);
  };

  const editor = useEditor({
    extensions: [
      StarterKit,
      Image,
      TextStyleKit,
      Color,
      TaskList,
      TaskItem,
      Highlight.configure({ multicolor: true }),
      Table.configure({
        resizable: true,
      }),
      TableRow,
      TableHeader,
      TableCell,
    ],
    content: parseContent(initialContent),
    onFocus() {
      if(onFocus) onFocus();
    },
    onBlur() {
      if(onBlur) onBlur();
    },
    onSelectionUpdate: ({ editor }) => {
      console.log("onSelectionUpdate triggered");
    },
    onUpdate: ({ editor }) => {
      console.log("onUpdate triggered");
      onEditing();
      handleTyping();
      const htmlContent = editor.getHTML();
      if (editable) debouncedUpdateFirestore(htmlContent);
    },
    editable: editable,
  });

  // This useEffect is causing content to be overwritten on re-renders.
  // The initial content is already set by the `content` property in `useEditor`.
  // useEffect(() => {
  //   if (editor && initialContent) {
  //     editor.commands.setContent(initialContent);
  //   }
  // }, [editor, initialContent]);

  useEffect(() => {
    if (editor && geminiData) {
      const newContent = parseContent(geminiData.text || geminiData.content);
      editor.commands.setContent(newContent);
      console.log("Editor content set with new Gemini data:", newContent);
    }
  }, [geminiData, editor]);

  // useEffect(() => {
  //   const handleKeyDown = (event) => {
  //     if (event.key === "/") {
  //       const editorViewDom = editor.view.dom;
  //       if (editorViewDom.contains(document.activeElement)) {
  //         const { top, left } = editor.view.dom.getBoundingClientRect();
  //         const { selection } = editor.view.state;
  //         const startPos = editor.view.coordsAtPos(selection.from);
  //         setMenuPosition({
  //           top: startPos.top + window.scrollY,
  //           left: startPos.left + window.scrollX,
  //         });
  //         setShowSideMenu(true);
  //       }
  //     }
  //   };

  //   document.addEventListener("keydown", handleKeyDown);
  //   return () => {
  //     document.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, [editor]);

  const addImage = () => {
    // Add image upload logic here
    const url = window.prompt("URL");
    if (url) {
      editor.chain().focus().setImage({ src: url }).run();
    }
  };

  return (
    <div className="tiptap" ref={editorRef} style={{ position: "relative" }}>
      <style>{`
        .bubble-menu-hidden {
          opacity: 0 !important;
          pointer-events: none;
          transition: opacity 0.2s ease-in-out;
        }
        .bubble-menu-visible {
          opacity: 1 !important;
          transition: opacity 0.2s ease-in-out;
        }
      `}</style>
      {editor && <EditorContent editor={editor} />}
      {editor && <CustomBubbleMenu 
        editor={editor} 
        addImage={addImage} 
        shouldShow={({ editor }) => editor.isFocused} 
        className={isTyping ? "bubble-menu-hidden" : "bubble-menu-visible"}
      />}
      {/* {showSideMenu && <TiptapSideMenu editor={editor} position={menuPosition} open={showSideMenu} onClose={() => setShowSideMenu(false)} />} */}
    </div>
  );
});

export default EditorsContainer;
